export default __webpack_public_path__ + "static/media/gm-evo-girl.be4e0377.webp";